import { render, staticRenderFns } from "./CategorySubcategories.vue?vue&type=template&id=dfcede30"
import script from "./CategorySubcategories.vue?vue&type=script&lang=js"
export * from "./CategorySubcategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports